import React from 'react'
import { AEMLinkProperties } from '@components/Form/FormTypes'

import CountdownTeaserButton from './CountdownTeaserButton'

interface CountdownTeaserProperties {
  title: string
  leadText: string
  description: string
  firstCtaLabel: string
  firstCtaLink: AEMLinkProperties
  secondCtaLabel: string
  secondCtaLink: AEMLinkProperties
}
const CountdownTeaser: React.FC<CountdownTeaserProperties> = ({
  title,
  leadText,
  description,
  firstCtaLabel,
  firstCtaLink,
  secondCtaLabel,
  secondCtaLink,
}: CountdownTeaserProperties) => {
  return (
    <div className="cmp-countdown-teaser">
      <h4 className="cmp-countdown-teaser__title">{title}</h4>
      <div className="cmp-countdown-teaser__lead-text">{leadText}</div>
      <div className="cmp-countdown-teaser__description" dangerouslySetInnerHTML={{ __html: description }} />
      <div className="cmp-countdown-teaser__actions">
        <CountdownTeaserButton
          className="cmp-countdown-teaser__primary-button"
          ctaLabel={firstCtaLabel}
          ctaLink={firstCtaLink}
        />
        <CountdownTeaserButton
          className="cmp-countdown-teaser__secondary-button"
          ctaLabel={secondCtaLabel}
          ctaLink={secondCtaLink}
        />
      </div>
    </div>
  )
}

export default CountdownTeaser
